// extracted by mini-css-extract-plugin
export const eyewearCard = "eyewear-card-module--eyewearCard--27Q0B";
export const closed = "eyewear-card-module--closed--3XNII";
export const toggleButton = "eyewear-card-module--toggleButton--HedVP";
export const minimize = "eyewear-card-module--minimize--2TpkS";
export const info = "eyewear-card-module--info--11QNH";
export const brand = "eyewear-card-module--brand--3fY8j";
export const name = "eyewear-card-module--name--kqM-K";
export const price = "eyewear-card-module--price--2QEal";
export const buynow = "eyewear-card-module--buynow--3WLh4";